import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { client, clientFormData, BASE_URL } from '../api/client';
import { getThunkName, printThunkName, updateThunkName } from './base';

export const thunkPerformanceDataApi = 'api/kelola-data-kinerja';
export const thunkRealisationPerformanceDataApi = 'input-realisasi';
export const slicePerformanceDataName = 'kelola-data-kinerja';
export const thunkPerformanceDataListEmployeeApi = 'api/kelola-data-kinerja/pegawai-list';
export const thunkRecapPerformanceDataApi = 'api/kelola-data-kinerja/rekap';
export const thunkPrintResult = 'cetak-pdf';
export const thunkRecapResult = 'rekap';

// Sasaran
export const getPerformanceData = createAsyncThunk(getThunkName(thunkPerformanceDataApi), async (params = '', { rejectWithValue }) => {
  try {
    const response = await client.get(BASE_URL + thunkPerformanceDataApi + '?' + params, {
      headers: {
        Authorization: localStorage.getItem('token'),
      },
    });
    return response.data;
  } catch (err) {
    return rejectWithValue(err);
  }
});

export const updatePerformanceData = createAsyncThunk(updateThunkName(thunkPerformanceDataApi), async ({ id, body }, { rejectWithValue }) => {
  try {
    const response = await clientFormData.post(BASE_URL + thunkPerformanceDataApi + '/' + id + '/' + thunkRealisationPerformanceDataApi, body, {
      headers: {
        Authorization: localStorage.getItem('token'),
      },
    });
    return response.data;
  } catch (err) {
    return rejectWithValue(err);
  }
});

export const recapPerformanceData = createAsyncThunk(thunkRecapPerformanceDataApi, async (params = '', { rejectWithValue }) => {
  try {
    const response = await client.get(BASE_URL + `${thunkPerformanceDataApi}/${thunkRecapResult}?${params}`, {
      headers: {
        Authorization: localStorage.getItem('token'),
      },
    });
    return response.data;
  } catch (err) {
    return rejectWithValue(err);
  }
});

export const downloadPerformanceData = createAsyncThunk(printThunkName(thunkPerformanceDataApi), async (params = '', { rejectWithValue }) => {
  try {
    const response = await client.get(BASE_URL + `${thunkPerformanceDataApi}/${thunkPrintResult}?${params}`, {
      headers: {
        Authorization: localStorage.getItem('token'),
      },
    });
    return response.data;
  } catch (err) {
    return rejectWithValue(err);
  }
});

export const PerformanceDataSlice = createSlice({
  name: slicePerformanceDataName,
  initialState: {
    get: {
      data: [],
      status: 'idle',
      message: '',
      error: '',
      pagination: {},
    },
    update: {
      data: {},
      status: 'idle',
      message: '',
      error: '',
    },
    recap: {
      data: {},
      status: 'idle',
      message: '',
      error: '',
    },
    download: {
      data: {},
      status: 'idle',
      message: '',
      error: '',
    },
  },
  reducers: {
    reset: (state) => {
      state.download = {
        data: {},
        status: 'idle',
        message: '',
        error: '',
      };
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getPerformanceData.pending, state => {
        state.get.data = [];
        state.get.status = 'loading';
        state.get.message = '';
        state.get.error = '';
        state.get.pagination = {};
      })
      .addCase(getPerformanceData.fulfilled, (state, action) => {
        state.get.data = action.payload.data;
        state.get.status = 'succeeded';
        state.get.message = action.payload.message;
        state.get.error = '';
        state.get.pagination = action.payload.meta;
      })
      .addCase(getPerformanceData.rejected, (state, action) => {
        state.get.data = [];
        state.get.status = 'failed';
        state.get.message = action.payload.message;
        state.get.error = action.payload.error;
        state.get.pagination = {};
      })
      .addCase(downloadPerformanceData.pending, state => {
        state.download.data = {};
        state.download.status = 'loading';
        state.download.message = '';
        state.download.error = '';
      })
      .addCase(downloadPerformanceData.fulfilled, (state, action) => {
        state.download.data = action.payload.data;
        state.download.status = 'succeeded';
        state.download.message = action.payload.message;
        state.download.error = '';
      })
      .addCase(downloadPerformanceData.rejected, (state, action) => {
        state.download.data = {};
        state.download.status = 'failed';
        state.download.message = action.payload.message;
        state.download.error = action.payload.error;
      })
      .addCase(updatePerformanceData.pending, state => {
        state.update.data = {};
        state.update.status = 'loading';
        state.update.message = '';
        state.update.error = '';
      })
      .addCase(updatePerformanceData.fulfilled, (state, action) => {
        state.update.data = action.payload.data;
        state.update.status = 'succeeded';
        state.update.message = action.payload.message;
        state.update.error = '';
      })
      .addCase(updatePerformanceData.rejected, (state, action) => {
        state.update.data = {};
        state.update.status = 'failed';
        state.update.message = action.payload.message;
        state.update.error = action.payload.error;
      })
      .addCase(recapPerformanceData.pending, state => {
        state.recap.data = [];
        state.recap.status = 'loading';
        state.recap.message = '';
        state.recap.error = '';
        state.recap.pagination = {};
      })
      .addCase(recapPerformanceData.fulfilled, (state, action) => {
        state.recap.data = action.payload.data;
        state.recap.status = 'succeeded';
        state.recap.message = action.payload.message;
        state.recap.error = '';
        state.recap.pagination = action.payload.meta;
      })
      .addCase(recapPerformanceData.rejected, (state, action) => {
        state.recap.data = [];
        state.recap.status = 'failed';
        state.recap.message = action.payload.message;
        state.recap.error = action.payload.error;
        state.recap.pagination = {};
      })
  },
});
export const { reset } = PerformanceDataSlice.actions;
export default PerformanceDataSlice.reducer;
